import TankLevelTemplateActionsTypes from '../actions/types/tankLevelTemplate';
import { ActionInterface, ErrorInterface, PaginatedListInterface } from '../../utils/types/common';
import {
  TankLevelTemplateInterface,
  TankLevelTemplateAction,
  TankLevelTemplateStateInterface
} from '../../utils/types/tankLevelTemplate';
import { getInitialPaginationState } from '../../utils/constants/states';

const initialPaginationState = getInitialPaginationState<TankLevelTemplateInterface>()

export const actionInitialState: ActionInterface = {
  loading: false,
  error: undefined,
  done: false
};

export const initialState: TankLevelTemplateStateInterface = {
  create: actionInitialState,
  list: { ...actionInitialState, data: initialPaginationState },
  view: {
    ...actionInitialState,
    data: {
      id: '',
      name: '',
      template: '',
      created_by: ''
    }
  },
  update: actionInitialState,
  delete: actionInitialState,
  complete: actionInitialState
};

export const reducer = (
  state = initialState,
  action: TankLevelTemplateAction
): TankLevelTemplateStateInterface => {
  switch (action.type) {
    case TankLevelTemplateActionsTypes.CREATE_TANK_LEVEL_TEMPLATE_IN_PROGRESS:
      return {
        ...state,
        create: {
          loading: true,
          error: undefined,
          done: false
        }
      };
    case TankLevelTemplateActionsTypes.CREATE_TANK_LEVEL_TEMPLATE_SUCCESS:
      return {
        ...state,
        create: {
          loading: false,
          error: undefined,
          done: true
        }
      };
    case TankLevelTemplateActionsTypes.CREATE_TANK_LEVEL_TEMPLATE_ERROR:
      return {
        ...state,
        create: {
          loading: false,
          error: action.payload as ErrorInterface,
          done: false
        }
      };

    case TankLevelTemplateActionsTypes.LIST_TANK_LEVEL_TEMPLATES_IN_PROGRESS:
      return {
        ...state,
        list: {
          loading: true,
          error: undefined,
          done: false
        }
      };
    case TankLevelTemplateActionsTypes.LIST_TANK_LEVEL_TEMPLATES_SUCCESS:
      return {
        ...state,
        list: {
          data: action.payload as PaginatedListInterface<TankLevelTemplateInterface>,
          loading: false,
          error: undefined,
          done: true
        }
      };
    case TankLevelTemplateActionsTypes.LIST_TANK_LEVEL_TEMPLATES_ERROR:
      return {
        ...state,
        list: {
          loading: false,
          error: action.payload as ErrorInterface,
          done: false
        }
      };

    case TankLevelTemplateActionsTypes.VIEW_TANK_LEVEL_TEMPLATE_IN_PROGRESS:
      return {
        ...state,
        view: {
          loading: true,
          error: undefined,
          done: false
        }
      };
    case TankLevelTemplateActionsTypes.VIEW_TANK_LEVEL_TEMPLATE_SUCCESS:
      return {
        ...state,
        view: {
          data: action.payload as any,
          loading: false,
          error: undefined,
          done: true
        }
      };
    case TankLevelTemplateActionsTypes.VIEW_TANK_LEVEL_TEMPLATE_ERROR:
      return {
        ...state,
        view: {
          loading: false,
          error: action.payload as ErrorInterface,
          done: false
        }
      };

    case TankLevelTemplateActionsTypes.UPDATE_TANK_LEVEL_TEMPLATE_IN_PROGRESS:
      return {
        ...state,
        update: {
          loading: true,
          error: undefined,
          done: false
        }
      };
    case TankLevelTemplateActionsTypes.UPDATE_TANK_LEVEL_TEMPLATE_SUCCESS:
      return {
        ...state,
        update: {
          loading: false,
          error: undefined,
          done: true
        }
      };
    case TankLevelTemplateActionsTypes.UPDATE_TANK_LEVEL_TEMPLATE_ERROR:
      return {
        ...state,
        update: {
          loading: false,
          error: action.payload as ErrorInterface,
          done: false
        }
      };

    case TankLevelTemplateActionsTypes.DELETE_TANK_LEVEL_TEMPLATE_IN_PROGRESS:
      return {
        ...state,
        delete: {
          loading: true,
          error: undefined,
          done: false
        }
      };
    case TankLevelTemplateActionsTypes.DELETE_TANK_LEVEL_TEMPLATE_SUCCESS:
      return {
        ...state,
        delete: {
          loading: false,
          error: undefined,
          done: true
        }
      };
    case TankLevelTemplateActionsTypes.DELETE_TANK_LEVEL_TEMPLATE_ERROR:
      return {
        ...state,
        delete: {
          loading: false,
          error: action.payload as ErrorInterface,
          done: false
        }
      };

    case TankLevelTemplateActionsTypes.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};
